/* // Correct
this.setState((state, props) => ({
  counter: state.counter + props.increment
}));
 */
import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import DreamsTable from "./dreamsTableShow";
import DreamsTableMob from "./dreamsTableShowMob";
//import DreamsTableMuraqeeb from "./dreamsTableMuraqeeb";
import AllDreams from "./allDreams";
import ListGroup from "./common/listGroup";
import Pagination from "./common/pagination";
import {
  saveDream,
  //  getDreams,
  // getDreamsReply,
  saveBulkDream,
  //getDreamsMuraqeeb,
  //getNonReplyMobDataDreams,
  //getDreamsREFRESHDATA,
  getCashU_MT_locked,
  //getCashU_MT_lockedReplyID,
  saveOPTOUT,
} from "../services/dreamService";
import {
  alldreamapi_NONREPLY_After_60,
  PostCashU_MT_UNLOCK_,
  POSTLockedـDelete_Dream_,
  alldreamapi_NONREPLY_Befor_60,
  alldreamapi_Before_30,
  alldreamapi_REPLY_Before_2,
  LockDream_Mob,
  DreamAdmin,
  getUpdateWorkCount_,
  getRep_,
} from "../services/dreamNewService";
import NavBar from "./navBar";
import { paginate } from "../utils/paginate";
import _ from "lodash";
import auth from "../services/authService";
import Modal from "react-modal";

import SearchBox from "./searchBox";
import { isBlockedShortCode } from "../utils/shortCodeStatus";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import DatePicker from "react-datepicker";
import DreamsTableForDoc from "./dreamTableForDoc";

Modal.setAppElement("#root");


function MyHTMLComponent({ htmlString }) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}


class Dreams extends Component {
  state = {
    dreams: [],
    dreams_Replyed_Deleted: [],
    dream: [],
    pcode: 777,
    sc: [],
    currentPage: 1,
    pageSize: 100,
    searchQuery: "",
    selectedGenre: null,
    customerRate: "100",
    sortColumn: { path: "MO_Date", order: "asc" },
    user: "",
    OfflineData: [],
    isStop: false,
    dreamsNONReplyMob: [],
    dreamsReplyMob: [],
    oldDreams: [],
    dreamsLast60Days: [],
    dreamsMobileApp: [],
    currentMufasser: "الكل",
    currentSC: "الكل",
    currentsc_new1: "الكل",
    currentsc_new2: null,
    currentsc_new3: null,
    currentsc_new4: null,
    currentShow: 0,
    sc_new1: [],
    sc_new2: [],
    sc_new3: [],
    sc_new4: [],
    mobile: "",
    shouldHide: true,
    showHide: true,
    showHideDoc: false,

    showReplyTable: false,
    messageLength: "50",
    currentStatus: "الكل",
    actionDate: null,
    currentDate: new Date(),
    mobileAllDreams: "",
    QutaibaM: 0,
    QutaibaD: 0,

    mohannadD: 0,
    mohannadM: 0,
    adibM: 0,
    adibD: 0,
    adibY: 0,
    QutaibaLM: 0,

    mohannadY: 0,
    QutaibaY: 0,

    OmarY: 0,
    OmarM: 0,
    OmarD: 0,
    OmarLM: 0,

    mohannadLM: 0,
    adibLM: 0,
    TodaySMS: 0,
    MonthSMS: 0,
    TodayCountMuraqeeb: 0,
    TodayCount: 0,
    MonthCount: 0,
    oldmonthSMS: 0,
    oldmonthCount: 0,

    yesterdaySMS: 0,
    yesterdayCount: 0,
  };

  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
  }

  async putUsed() {
    const email = await auth.getCurrentUser();
    const [getDetails, repDetails] = await Promise.all([
      getUpdateWorkCount_(email),
      getRep_(email),
    ]);
    if (this.state.pcode === 999) {
      let TodaySMS = getDetails.data.TodaySMS;
      let MonthSMS = getDetails.data.MonthSMS;
      const TodayCountMuraqeeb = getDetails.data.TodayCountMuraqeeb;
      const TodayCount = getDetails.data.TodayCount;
      const MonthCount = getDetails.data.MonthCount;
      let oldmonthSMS = getDetails.data.oldmonthSMS;
      const oldmonthCount = getDetails.data.oldmonthCount;
      const replyusersummarytoday = getDetails.data.replyusersummarytoday;
      const replyusersummaryMonth = getDetails.data.replyusersummaryMonth;
      const ReplyusersummaryoldMonth = getDetails.data.ReplyusersummaryoldMonth;
      const replyusersummaryYesterday =
        getDetails.data.replyusersummaryYesterday;
      let yesterdaySMS = getDetails.data.yesterdaySMS;
      const yesterdayCount = getDetails.data.yesterdayCount;

      let mohannadY = 0;
      let QutaibaM = 0;
      let QutaibaD = 0;
      let QutaibaY = 0;
      let OmarM = 0;
      let OmarD = 0;
      let OmarY = 0;

      let mohannadD = 0;
      let mohannadM = 0;
      let adibM = 0;
      let adibD = 0;
      let adibY = 0;
      let QutaibaLM = 0;
      let OmarLM = 0;
      let mohannadLM = 0;
      let adibLM = 0;
      console.log(replyusersummaryYesterday);
      const repData = repDetails && repDetails.data ? repDetails.data : null;
      if (repData) {
        const sumAhlamkom = (items) =>
          (items || []).reduce((sum, item) => {
            const code = Number(item.ShortCode);
            if (Number.isNaN(code) || isBlockedShortCode(code)) {
              return sum;
            }
            const count = Number(item.CountMsg) || 0;
            return sum + count;
          }, 0);

        const today = new Date();
        const todayDay = today.getDate();
        const todayMonth = today.getMonth() + 1;
        const todayYear = today.getFullYear();

        const yesterday = new Date(today);
        yesterday.setDate(todayDay - 1);
        const yDay = yesterday.getDate();
        const yMonth = yesterday.getMonth() + 1;
        const yYear = yesterday.getFullYear();

        const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonth = lastMonthDate.getMonth() + 1;
        const lastMonthYear = lastMonthDate.getFullYear();

        const dayItems = (repData.SCDMY || []).filter(
          (item) =>
            item.Day === todayDay &&
            item.Month === todayMonth &&
            item.Year === todayYear
        );
        const yesterdayItems = (repData.SCDMY || []).filter(
          (item) =>
            item.Day === yDay && item.Month === yMonth && item.Year === yYear
        );
        const monthItems = (repData.SCMY || []).filter(
          (item) => item.Month === todayMonth && item.Year === todayYear
        );
        const lastMonthItems = (repData.SCMY || []).filter(
          (item) => item.Month === lastMonth && item.Year === lastMonthYear
        );

        TodaySMS = sumAhlamkom(dayItems);
        yesterdaySMS = sumAhlamkom(yesterdayItems);
        MonthSMS = sumAhlamkom(monthItems);
        oldmonthSMS = sumAhlamkom(lastMonthItems);
      }
      replyusersummaryYesterday.forEach((d) => {
        if (d.ReplyUserName === "adib@salmustasharak.com") {
          adibY = d.Count;
        }
        if (d.ReplyUserName === "mohannad@salmustasharak.com") {
          mohannadY = d.Count;
        }

        if (d.ReplyUserName === "qutaiba@salmustasharak.com") {
          QutaibaY = d.Count;
        }
      });

      replyusersummarytoday.forEach((d) => {
        if (d.ReplyUserName === "adib@salmustasharak.com") {
          adibD = d.Count;
        }
        if (d.ReplyUserName === "mohannad@salmustasharak.com") {
          mohannadD = d.Count;
        }

        if (d.ReplyUserName === "qutaiba@salmustasharak.com") {
          QutaibaD = d.Count;
        }
      });
      replyusersummaryMonth.forEach((d) => {
        if (d.ReplyUserName === "adib@salmustasharak.com") {
          adibM = d.Count;
        }
        if (d.ReplyUserName === "mohannad@salmustasharak.com") {
          mohannadM = d.Count;
        }

        if (d.ReplyUserName === "qutaiba@salmustasharak.com") {
          QutaibaM = d.Count;
        }
      });
      ReplyusersummaryoldMonth.forEach((d) => {
        if (d.ReplyUserName === "adib@salmustasharak.com") {
          adibLM = d.Count;
        }
        if (d.ReplyUserName === "mohannad@salmustasharak.com") {
          mohannadLM = d.Count;
        }

        if (d.ReplyUserName === "qutaiba@salmustasharak.com") {
          QutaibaLM = d.Count;
        }
      });
      this.setState({
        TodaySMS,
        MonthSMS,
        TodayCountMuraqeeb,
        TodayCount,
        MonthCount,
        oldmonthSMS,
        oldmonthCount,

        yesterdaySMS,
        yesterdayCount,

        QutaibaM,
        QutaibaD,

        mohannadD,
        mohannadM,
        adibM,
        adibD,
        adibY,
        QutaibaLM,

        mohannadY,
        QutaibaY,

        OmarY,
        OmarM,
        OmarD,
        OmarLM,
        mohannadLM,
        adibLM,
      });
    } else {
      const TodayCount = getDetails.data.TodayCount;
      const MonthCount = getDetails.data.MonthCount;
      const oldmonthCount = getDetails.data.oldmonthCount;
      this.setState({
        // sc,

        TodayCount,
        MonthCount,
        oldmonthCount,
      });
    }
  }

  async openModal(dream) {
    // let alldata = await getOldDreams(dream.MT_Mobil.replace("+", ""));
    // alldata = [...alldata.data.Data, ...alldata.data.OldData];
    this.setState({ mobileAllDreams: dream.MT_Mobil });
    //////console.log(dream);
    const mob = dream.MT_Mobil.replace("+", "");
    //window.location =   ;
    window.open("/alldreams/" + mob, "_blank");
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  async tick() {
    try {
      const email = auth.getCurrentUser();
      if (this.state.showHide) {
        //////console.log(currentDate);
        if (email) {
          if (this.state.pcode === 999) {
            const data = await alldreamapi_NONREPLY_After_60();
            const dataReplyedDeleted = await alldreamapi_Before_30();

            //////console.log("this.state.actionDate === null" + this.state.actionDate);
            const dream = this.state.dream;

            var dreams = data.data.Data;
            if (dream.length > 0) {
              const dreams_ = dreams.filter((m) => m.ReplyID !== dream.ReplyID);
              let dreams = [...dreams_, dream];
            }
            const dataordered = _.orderBy(dreams, "ReplyID", "asc");

            // //////console.log(dataordered);
            //  //////console.log(dataReplyedDeleted.data.Data);
            this.setState({
              dreams: dataordered,
              dreams_Replyed_Deleted: dataReplyedDeleted.data.Data,
              dream: [],
            });
          } else {
            const data = await alldreamapi_NONREPLY_After_60();

            const dream = this.state.dream;
            var dreams = data.data.Data;
            if (dream.length > 0) {
              const dreams_ = dreams.filter((m) => m.ReplyID !== dream.ReplyID);
              let dreams = [...dreams_, dream];
            }
            const dataordered = _.orderBy(dreams, "ReplyID", "asc");

            this.setState({
              dreams: dataordered,
              dream: [],
            });
          }
        }
      }
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This mob has already been deleted.");
    }
  }

  async componentDidMount() {
    const email = auth.getCurrentUser();

    if (!email) {
      toast.error("حدث خطأ يرجى الخروج وإعادة الدخول");
      return;
    }
    try {
      this.timerID = setInterval(async () => {
        const currentDate = new Date();
        //////console.log(currentDate);
        currentDate.setSeconds(currentDate.getSeconds() + 60);
        if (this.state.actionDate < currentDate) {
          if (!this.state.isStop) {
            await this.tick();
          }
        }
        await this.putUsed();
      }, 60000);
    } catch (e) { }

    if (
      email.toLowerCase().startsWith("adib") ||
      email.toLowerCase().startsWith("mohannad")
    ) {
      this.setState({
        user: email,
        pcode: 999,
      });
      await this.putUsed();
    } else if (email.toLowerCase().startsWith("alaa")) {
      this.setState({
        user: email,
        pcode: 300,
      });
    } else {
      this.setState({
        user: email,
        pcode: 123,
      });
    }

    const data = await alldreamapi_NONREPLY_After_60();

    let data12 = localStorage.getItem("OfflineData");
    if (data12) {
      if (!data12.startsWith("[")) {
        data12 = "[" + data12 + "]";
      }
    }

    let OfflineData = JSON.parse(data12);
    // const OfflineData=JSON.parse(localStorage.getItem("OfflineData"));
    let sc_new1 = [];
    let sc_new2 = [];
    let sc_new3 = [];
    let sc_new4 = [];
    if (this.state.pcode === 999) {
      sc_new1 = [
        {
          title: "الكل",
          active: false,
        },
        {
          title: "حروف",
          active: false,
        },
      ];
      sc_new2 = [
        {
          title: "اليوم",
          active: true,
        },
        {
          title: "البارحة",
          active: false,
        },
        {
          title: "تاريخ",
          active: false,
        },
      ];
      sc_new3 = [];
      sc_new4 = [
        {
          title: "جديد",
          active: false,
        },
        {
          title: "خاص",
          active: false,
        },
        {
          title: "محجوز",
          active: false,
        },
        {
          title: "تدقيق",
          active: false,
        },
        {
          title: "Offline",
          active: false,
        },
        {
          title: "المرسلة",
          active: false,
        },
        {
          title: "المحذوفة",
          active: false,
        },
        {
          title: "الموبايل",
          active: false,
        },
      ];
    } else if (this.state.pcode === 888) {
      sc_new1 = [];
      sc_new2 = [
        {
          title: "اليوم",
          active: true,
        },
        {
          title: "البارحة",
          active: false,
        },
        {
          title: "الأسبوع",
          active: false,
        },
        {
          title: "الشهر",
          active: false,
        },
        {
          title: "تاريخ",
          active: false,
        },
      ];

      sc_new4 = [
        {
          title: "جديد",
          active: false,
        },
      ];
    } else {
      sc_new1 = [
        {
          title: "الكل",
          active: false,
        },
      ];
      sc_new2 = [];
      sc_new3 = [];
      sc_new4 = [
        {
          title: "Offline",
          active: false,
        },
      ];
    }

    const sc = data.data.SC;
    console.log(sc);
    const currentDate = new Date();
    var dreams = data.data.Data;

    const dataordered = _.orderBy(dreams, "ReplyID", "asc");
    var dreamId = dataordered[0]["ReplyID"];

    this.setState({
      dreams: dataordered,
      sc,
      loading: false,
      sc_new1,
      sc_new2,
      sc_new3,
      sc_new4,
    });

    const oldDreams = await alldreamapi_NONREPLY_Befor_60();
    //console.log(oldDreams);
    this.setState({
      oldDreams: oldDreams.data,
    });
  }

  handleImage = async (mobile) => {
    const mob = { Mobile: mobile };
    try {
      await saveOPTOUT(mob);
      toast.info("تم  حذف الرقم من الترويج", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This mob has already been deleted.");
    }
  };

  handleChangeDP = (date) => {
    const currentDate = date;
    if (date === "") {
      this.setState({
        currentDate: null,
      });
    } else {
      this.setState({
        currentDate,
      });
    }

    ////////////console.log(this.state.currentDate);
  };
  renderSortIcon = () => {
    const { sortColumn } = this.state;

    if ("MO_Date" !== sortColumn.path) return null;

    if (sortColumn.order === "asc") return <i className="fa fa-sort-asc" />;
    return <i className="fa fa-sort-desc" />;
  };
  handleAdminSendMessage = async (dream) => {
    if (dream.isSent) {
      if (dream["MsgRegFroSend"] === 1) {
        dream["MsgRegFroSend"] = 2;
      } else if (dream["MsgRegFroSend"] === 2) {
        dream["MsgRegFroSend"] = 3;
      } else if (dream["MsgRegFroSend"] === 3) {
        dream["MsgRegFroSend"] = 4;
      }
      dream["isSent"] = false;

      await DreamAdmin(dream);
    } else if (dream.IsReply) {
      dream["ReplyDate"] = new Date();
      dream["isRedyToSent"] = true;
      dream["MsgRegFroSend"] = 1;
      dream["Userlock"] = this.state.user;
      dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
      dream["IsPending"] = true;
      dream["IsReply"] = true;
      await DreamAdmin(dream);
    }
  };

  handleGetAll = async (mobile) => {
    ////////console.log(raw);
    const dreams = this.state.dreams;
    if (this.state.currentsc_new4 === "تدقيق") {
      const dreamsNONReplyMob = dreams.filter(
        (a) => a.MT_Mobil === mobile && a.isRedyToSent === false
      );

      this.setState({
        shouldHide: false,
        mobile,
        dreamsNONReplyMob,
      });
    } else {
      if (this.state.pcode > 777) {
        const dreamsNONReplyMob = dreams.filter(
          (a) => a.MT_Mobil === mobile && a.isRedyToSent === false
        );

        this.setState({
          shouldHide: false,
          mobile,
          dreamsNONReplyMob,
        });
      } else if (this.state.pcode === 300) {
        const dreams = this.state.dreams;

        const dreamsNONReplyMob = dreams.filter(
          (a) =>
            (a.MOShortCode !== 4060 &&
              a.MT_Mobil === mobile &&
              a.IsReply === false) ||
            (a.MOShortCode !== 4060 &&
              a.islock === true &&
              a.MT_Mobil === mobile &&
              a.ReplyUserName === this.state.user &&
              a.IsReply === false)
        );

        this.setState({
          shouldHide: false,
          dreamsNONReplyMob,
          mobile,
        });
      } else {
        const dreams = this.state.dreams;
        var dToday = new Date();

        dToday.setHours(dToday.getHours() - 4);

        let allDreams = dreams.filter((m) => {
          var date = new Date(m["MO_Date"]);
          return (
            m.MOShortCode !== 4060
          );
        });

        const dreamsNONReplyMob = allDreams.filter(
          (a) =>
            (a.MT_Mobil === mobile && a.IsReply === false) ||
            (a.MT_Mobil === mobile &&
              a.islock === true &&
              a.ReplyUserName === this.state.user &&
              a.IsReply === false)
        );

        this.setState({
          shouldHide: false,
          dreamsNONReplyMob,
          mobile,
        });
      }

      const raw = await LockDream_Mob(mobile, true);

      if (raw.data.eraw === 0) {
        const dreamsNONReplyMob = dreams.filter(
          (a) => a.MT_Mobil === mobile && a.Userlock === this.state.user
        );
        //////console.log(dreamsNONReplyMob);
        //////console.log(this.state.email);
        if (dreamsNONReplyMob.length === 0) {
          toast.warn("هذا الرقم لم يتم حجز أحلامه");
          this.setState({
            shouldHide: true,
            dreamsNONReplyMob: [],
            mobile: "",
          });
          return;
        }
      }
    }
  };

  onUnLockAll = async (mobile) => {
    if (this.state.pcode === 999) {
      this.setState({
        shouldHide: true,
        mobile: "",
        dreamsNONReplyMob: [],
      });
    } else {
      this.setState({
        shouldHide: true,
        dreamsNONReplyMob: [],
        mobile: "",
      });
    }
    const raw = await LockDream_Mob(mobile, false);
  };

  handleShowHide = async () => {
    this.setState({
      showHide: !this.state.showHide,
    });
  };


  handleShowHideDoc = async () => {
    this.setState({
      showHideDoc: !this.state.showHideDoc,
    });
  };

  handlerefreshData = async () => {
    //////////console.log(this.state.user);
    this.setState({
      loadeddata: false,
    });
    let dataoffline = localStorage.getItem("OfflineData");
    if (dataoffline) {
      if (!dataoffline.startsWith("[")) {
        dataoffline = "[" + dataoffline + "]";
      }
    }

    await this.UpdateALLDATA(null, null);
    this.setState({
      loadeddata: true,
      lastUpdateDate: new Date(),
    });

    // const data = await getAllDreams_(this.state.user);

    // const sc = data.data.SC;

    // var dreams = data.data.Data;

    // const dataordered = _.orderBy(dreams, "ReplyID", "desc");
    // var dreamId = dataordered[0]["ReplyID"];
    // //////////////console.log(dreamId);
    // // SC = sc,
    // // Data = cashU_MT,
    // var dataMuraqeeb = data.data.DataMuraqeeb;

    // // var dreams=data.Data.filter(a=> a.isdelete===false && a.isSent ===false)

    // this.setState({
    //   dreams: dreams,
    //   sc,
    //   loading: true,
    //   dataMuraqeeb,

    //   lastID: dreamId,

    // });
  };

  renderSortDate = () => {
    const { sortColumn } = this.state;

    sortColumn.order === "asc"
      ? this.setState({ sortColumn: { path: "MO_Date", order: "desc" } })
      : this.setState({ sortColumn: { path: "MO_Date", order: "asc" } });
    if (sortColumn.order === "asc") {
      return <i className="fa fa-sort-asc" />;
    } else {
      return <i className="fa fa-sort-desc" />;
    }
  };

  renderSortDate2 = () => {
    const { sortColumn } = this.state;

    sortColumn.order === "asc"
      ? this.setState({ sortColumn: { path: "RefNo", order: "desc" } })
      : this.setState({ sortColumn: { path: "RefNo", order: "asc" } });
    if (sortColumn.order === "asc") {
      return <i className="fa fa-sort-asc" />;
    } else {
      return <i className="fa fa-sort-desc" />;
    }
  };

  handleDeleteConfirm = (dream) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>حذف الحلم</h1>
            <p>هل ترغب بحذف الحلم</p>
            <button onClick={onClose}>لا</button>
            <button
              onClick={() => {
                this.handleDelete(dream);
                onClose();
              }}
            >
              نعم قم بحذفه
            </button>
          </div>
        );
      },
    });
  };

  handlerCBMob = (event) => {
    this.setState({ isFillterbyMob: event.target.checked });
  };

  handlerCBOffline = (event) => {
    this.setState({ isOffline: event.target.checked });
  };
  getMobFoucs = (dream, name, val) => {
    /*  if (this.state.isFillterbyMob) {
      const slectedMo = dream["MT_Mobil"];
      const dreams = [...this.state.dreams];

      const index = dreams.indexOf(dream);

      dreams[index][name] = val;

      this.setState({ slectedMo, dreams });
    } else {
      const dreams = [...this.state.dreams];

      const index = dreams.indexOf(dream);

      dreams[index][name] = val;

      this.setState({ dreams });
    } */
  };

  handledeleteDreamAction = async (dream) => {
    let data = localStorage.getItem("OfflineData");
    let offlinedata = JSON.parse(data);

    if (this.state.currentsc_new4 === "المرسلة") {
      const originalDreams = this.state.dreams_Replyed_Deleted;
      const dreams_ = originalDreams.filter((m) => m.ReplyID !== dream.ReplyID);
      let dreams = [...dreams_, dream];

      this.setState({
        dreams_Replyed_Deleted: dreams,
        dream,
        actionDate: new Date(),
      });

      if (data) {
        if (!data.startsWith("[")) {
          data = "[" + data + "]";
        }
      }
      if (dream.MT_Reply_Msg.length > 15 || dream.MT_Reply_Msg === "") {
        // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
        if (offlinedata) {
          if (offlinedata.length > 400) {
            offlinedata.splice(0, 1);
          }
          offlinedata = [...offlinedata, dream];
          this.setState({ OfflineData: offlinedata });
          offlinedata = JSON.stringify(offlinedata);
          localStorage.setItem("OfflineData", offlinedata);
        } else {
          this.setState({ OfflineData: dream });
          localStorage.setItem("OfflineData", JSON.stringify(dream));
        }
      }
    } else {
      if (this.state.shouldHide) {
        const originalDreams = this.state.dreams;
        const dreams_ = originalDreams.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );
        let dreams;
        if (dream.isdelete) {
          dreams = [...dreams_];
        } else if (dream.isRedyToSent) {
          dreams = [...dreams_];
        } else if (dream.IsReply) {
          dreams = [...dreams_];
        } else {
          dreams = [...dreams_, dream];
        }

        this.setState({
          dreams,
          dream,
          actionDate: new Date(),
        });
      } else {
        const originalDreams = this.state.dreams;
        const originalDreamsNONReply = this.state.dreamsNONReplyMob;
        const dreams_ = originalDreams.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );
        const dreams_NONReply = originalDreamsNONReply.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );
        let dreams;
        let dreamsNONReply;

        if (dream.isdelete) {
          dreams = [...dreams_];
          dreamsNONReply = [...dreams_NONReply];
        } else if (dream.isRedyToSent) {
          dreams = [...dreams_];
          dreamsNONReply = [...dreams_NONReply];
        } else if (dream.IsReply) {
          dreams = [...dreams_];
          dreamsNONReply = [...dreams_NONReply];
        } else {
          dreams = [...dreams_, dream];
          dreamsNONReply = [...dreams_NONReply, dream];
        }

        if (dreams_NONReply.length === 0) {
          this.setState({
            dreams,
            dream,
            actionDate: new Date(),
            shouldHide: true,
            dreamsNONReplyMob: [],
            mobile: "",
          });
        } else {
          this.setState({
            dreams,
            dream,
            actionDate: new Date(),
            dreamsNONReplyMob: dreamsNONReply,
          });
        }
      }
      if (!dream.isdelete) {
        if (dream.MT_Reply_Msg) {
          if (dream.MT_Reply_Msg.length > 15) {
            //   let offlinedata = JSON.parse(data);
            // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
            if (offlinedata) {
              if (offlinedata.length > 400) {
                offlinedata.splice(0, 1);
              }
              offlinedata = [...offlinedata, dream];
              this.setState({ OfflineData: offlinedata });
              offlinedata = JSON.stringify(offlinedata);
              localStorage.setItem("OfflineData", offlinedata);
            } else {
              this.setState({ OfflineData: dream });
              localStorage.setItem("OfflineData", JSON.stringify(dream));
            }
          }
        }
      }
    }
  };
  handleDelete = async (dream) => {
    dream["UserTranslate"] = this.state.lastID;
    //////////////console.log(dream);

    if (this.state.selectedGenre === "تدقيق") {
      dream["MT_Date"] = new Date();
      dream["ReplyDate"] = new Date();
      dream["isdelete"] = true;

      dream["ReplyUserName"] = this.state.user;

      const originalDreams = this.state.dataMuraqeeb;

      const dreams = originalDreams.filter((m) => m.ReplyID !== dream.ReplyID);
      // ////////////console.log(this.state.shouldHide);
      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = this.state.dreamsNONReplyMob.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );

        let shouldHide = false;

        //  ////////////console.log(dreamsNONReplyMob.length);
        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          this.setState({
            dreams,

            dreamsNONReplyMob,
            shouldHide,
            mobile,
            lastUpdateDate: new Date(),
          });
        } else {
          shouldHide = false;
          this.setState({
            dreams,

            dreamsNONReplyMob,
            shouldHide,
            lastUpdateDate: new Date(),
          });
        }
      } else {
        this.setState({ dataMuraqeeb: dreams, lastUpdateDate: new Date() });
      }

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);

          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        await saveDream(dream);

        toast.info("تم الحذف بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالحذف ", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.");
      }
      await this.UpdateALLDATA(null, dream);
    } else {
      dream["MT_Date"] = new Date();
      dream["ReplyDate"] = new Date();
      dream["isdelete"] = true;
      dream["ReplyUserName"] = this.state.user;

      const originalDreams = this.state.dreams;

      const dreams = originalDreams.filter((m) => m.ReplyID !== dream.ReplyID);
      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = this.state.dreamsNONReplyMob.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );

        let shouldHide = false;

        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          this.setState({
            dreams,

            dreamsNONReplyMob,
            shouldHide,
            mobile,
          });
        } else {
          shouldHide = false;
          this.setState({
            dreams,

            lastUpdateDate: new Date(),
            dreamsNONReplyMob,
            shouldHide,
          });
        }
      } else {
        this.setState({ dreams, lastUpdateDate: new Date() });
      }

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);

          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        await saveDream(dream);

        toast.info("تم الحذف بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالحذف ", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
      }
      await this.UpdateALLDATA(dream, null);
    }
  };

  handleKeywordsMsg = async (dream, keywords, pStatus) => {
    dream["UserTranslate"] = this.state.lastID;

    if (keywords) {
      if (keywords.length === 0 || keywords === " ") {
        toast.error("اكتب الرموز اولا ");
        return;
      }

      dream["MT_Englsih"] = keywords.replace(" ", "-");
    }

    dream["PersonStatus"] = pStatus;
    dream["SupervisorName"] = this.state.user;

    const originalDreams = this.state.dreams;

    //  const dreams = originalDreams.filter(m => m.ReplyID !== dream.ReplyID);
    const replyDreams = [...this.state.replyDreams, dream];

    this.setState({ dreams: originalDreams, replyDreams });

    try {
      if (this.state.isOffline) {
        let data = localStorage.getItem("OfflineData");
        if (data) {
          if (!data.startsWith("[")) {
            data = "[" + data + "]";
          }
        }
        let offlinedata = JSON.parse(data);
        // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
        if (offlinedata) {
          offlinedata = [...offlinedata, dream];
          this.setState({ OfflineData: offlinedata });
          offlinedata = JSON.stringify(offlinedata);
          localStorage.setItem("OfflineData", offlinedata);
        } else {
          this.setState({ OfflineData: dream });
          localStorage.setItem("OfflineData", JSON.stringify(dream));
        }
        return;
      }

      await saveDream(dream);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
    }

    /*  const dataNew = await getDreams();
        let dreamsNew = dataNew.data.Data;
        let dataMuraqeeb = await getDreamsMuraqeeb();
        dataMuraqeeb=dataMuraqeeb.data.Data;
        this.setState({
          dataMuraqeeb,
          dreams:dreamsNew
        }); */
  };

  sentOfflineData = async () => {
    let data = localStorage.getItem("OfflineData");
    if (data) {
      if (!data.startsWith("[")) {
        data = "[" + data + "]";
      }
    }
    let offlinedata = JSON.parse(data);
    localStorage.removeItem("OfflineData");
    //////////////console.log(data);

    this.setState({
      OfflineData: null,
    });

    try {
      let data = await saveBulkDream(offlinedata);

      // let newDreams = data.data.Data;

      // let Muraqeeb = data.data.Muraqeeb;

      this.setState({
        // dreams: newDreams,
        // dataMuraqeeb: Muraqeeb,
        todayCount: data.data.TodayCount,
        monthCount: data.data.MonthCount,
        //  yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb,
        //  todaysms: data.data.TodaySMS,
        // monthsms: data.data.MonthSMS
      });
      toast.info("تم الارسال لكل أحلام الأوفلاين بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالارسال ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });

      this.setState({
        OfflineData: offlinedata.length,
      });

      localStorage.setItem("OfflineData", JSON.stringify(offlinedata));

      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
    }
  };
  handleMessageLength = ({ currentTarget: input }) => {
    ////////////console.log(input.value);
    this.setState({ messageLength: input.value });
  };
  handleChangeInput = async (dream, name, val) => {
    name = name === "personStatus" ? "PersonStatus" : name;
    //  if(input.value.length < 10){
    // return  toast.error("الرسالة أقل من 10 حروف ");
    //  }{}

    const updateDreamInList = (list, fieldName, fieldValue) => {
      const source = Array.isArray(list) ? [...list] : [];
      const itemIndex = source.findIndex((item) => item.ReplyID === dream.ReplyID);

      if (itemIndex === -1) {
        return source;
      }

      source[itemIndex] = {
        ...source[itemIndex],
        ...dream,
        [fieldName]: fieldValue,
      };

      return source;
    };

    const getLatestFieldValue = (fieldName, fallbackValue) => {
      const lists = [
        this.state.dreams,
        this.state.dataMuraqeeb,
        this.state.tempDataMuraqeeb,
        this.state.dreamsNONReplyMob,
      ];

      for (const list of lists) {
        if (!Array.isArray(list)) continue;
        const item = list.find((entry) => entry.ReplyID === dream.ReplyID);
        if (
          item &&
          item[fieldName] !== undefined &&
          item[fieldName] !== null
        ) {
          return item[fieldName];
        }
      }

      if (dream[fieldName] !== undefined && dream[fieldName] !== null) {
        return dream[fieldName];
      }

      return fallbackValue;
    };

    const islocked = dream.islock;
    let dreams = [...this.state.dreams];

    const applyLocalDreamChange = () => {
      if (!this.state.shouldHide) {
        this.setState({
          dreams: updateDreamInList(this.state.dreams, name, val),
          dreamsNONReplyMob: updateDreamInList(
            this.state.dreamsNONReplyMob,
            name,
            val
          ),
        });
        return;
      }

      if (this.state.selectedGenre === "تدقيق") {
        this.setState({
          dreams: updateDreamInList(this.state.dreams, name, val),
          dataMuraqeeb: updateDreamInList(this.state.dataMuraqeeb, name, val),
          tempDataMuraqeeb: updateDreamInList(
            this.state.tempDataMuraqeeb,
            name,
            val
          ),
        });
        return;
      }

      this.setState({
        dreams: updateDreamInList(this.state.dreams, name, val),
      });
    };

    if (name === "PersonStatus") {
      dream[name] = val;
      applyLocalDreamChange();
      return;
    }

    //////////console.log(!islocked);

    if (
      islocked &&
      this.state.selectedGenre !== "تدقيق" &&
      dream.Userlock &&
      dream.Userlock !== this.state.user
    ) {
      toast.warn("لماذا تفسر حلم محجوز من قبل مفسر آخر !!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }

    if (!islocked) {
      dream.Userlock = this.state.user;
      dream.userlockDate = new Date();
      dream.islock = true;
    }

    dream[name] = val;
    applyLocalDreamChange();

    if (!islocked) {
      try {
        if (this.state.isOffline) {
          return;
        }

        let data = await POSTLockedـDelete_Dream_(dream);
        //////////console.log(data);
        if (data.data.Message === "locked") {
          toast.warn("هذا الحلم محجوز من قبل مفسر آخر", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          const latestValue = getLatestFieldValue(name, val);
          dream.Userlock = "";
          dream.userlockDate = null;
          dream.islock = false;
          dream[name] = latestValue;
          this.setState({
            dreams: updateDreamInList(this.state.dreams, name, latestValue),
            dreamsNONReplyMob: updateDreamInList(
              this.state.dreamsNONReplyMob,
              name,
              latestValue
            ),
            dataMuraqeeb: updateDreamInList(this.state.dataMuraqeeb, name, latestValue),
            tempDataMuraqeeb: updateDreamInList(
              this.state.tempDataMuraqeeb,
              name,
              latestValue
            ),
          });
          // await this.UpdateALLDATA(null, null);
          return;
        } else if (data.data.Message === "deleted") {
          toast.warn("هذا الحلم محذوف ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          dreams = dreams.filter((a) => a.ReplyID !== dream.ReplyID);

          this.setState({ dreams });
          //  await this.UpdateALLDATA(null, null);
          return;
        } else if (data.data.Message === "replyed") {
          toast.warn("هذا الحلم تم الرد عليه ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          dreams = dreams.filter((a) => a.ReplyID !== dream.ReplyID);
          this.setState({ dreams });
          //   await this.UpdateALLDATA(null, null);
          return;
        }

        //   await this.UpdateALLDATA(null,null)
      } catch (ex) {
        // toast.error("يوجد خطأ بالحفظ ", {
        //   position: toast.POSITION.BOTTOM_LEFT
        // });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
      }
    } else {
      if (this.state.selectedGenre !== "تدقيق") {
        if (dream.Userlock && dream.Userlock !== this.state.user) {
          toast.warn("لماذا تفسر حلم محجوز من قبل مفسر آخر !!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return;
        }
      }
    }
  };

  handleSendMsg = async (dream) => {
    this.setState({
      isStop: false,
    });
    if (this.state.pcode === 999) {
      if (dream["MT_Reply_Msg"]) {
        if (dream["MT_Reply_Msg"].length < 7) {
          toast.error("اكتب الرسالة اولا ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return;
        }
      } else {
        toast.error("اكتب الرسالة اولا ", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }

      if (this.state.selectedGenre === "تدقيق" || dream["IsReply"]) {
        dream["ReplyDate"] = new Date();
        dream["isRedyToSent"] = true;
        dream["MsgRegFroSend"] = 1;
        dream["Userlock"] = this.state.user;
        // dream["MT_Reply_Msg"] = msg;
        dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
        dream["IsPending"] = true;
        dream["IsReply"] = true;

        // dream["PersonStatus"] = pStatus;
        //dream["ReplyUserName"] = this.state.user;

        let originalDreams = [...this.state.dataMuraqeeb];
        let tempDataMuraqeeb = [...this.state.tempDataMuraqeeb];

        tempDataMuraqeeb = tempDataMuraqeeb.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );
        originalDreams = originalDreams.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );
        if (!this.state.shouldHide) {
          let dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
          dreamsNONReplyMob = dreamsNONReplyMob.filter(
            (m) => m.ReplyID !== dream.ReplyID
          );
          // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
          let shouldHide = false;
          // ////////////console.log(dreamsNONReplyMob.length===0);
          if (dreamsNONReplyMob.length === 0) {
            shouldHide = true;

            const mobile = "";
            dreamsNONReplyMob = [];
            ////////////console.log(dreamsNONReplyMob.length);
            this.setState({
              dataMuraqeeb: originalDreams,
              tempDataMuraqeeb,
              dreamsNONReplyMob,
              shouldHide,
              mobile,
              lastUpdateDate: new Date(),
            });
          } else {
            shouldHide = false;
            this.setState({
              dataMuraqeeb: originalDreams,
              dreamsNONReplyMob,
              shouldHide,
              tempDataMuraqeeb,
              lastUpdateDate: new Date(),
            });
          }
        } else {
          this.setState({
            dataMuraqeeb: originalDreams,
            tempDataMuraqeeb,
            lastUpdateDate: new Date(),
          });
        }

        // const replyDreams = [...this.state.replyDreams, dream];

        try {
          if (this.state.isOffline) {
            let data = localStorage.getItem("OfflineData");
            if (data) {
              if (!data.startsWith("[")) {
                data = "[" + data + "]";
              }
            }
            let offlinedata = JSON.parse(data);
            // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
            if (offlinedata) {
              offlinedata = [...offlinedata, dream];
              this.setState({ OfflineData: offlinedata });
              offlinedata = JSON.stringify(offlinedata);
              localStorage.setItem("OfflineData", offlinedata);
            } else {
              this.setState({ OfflineData: dream });
              localStorage.setItem("OfflineData", JSON.stringify(dream));
            }
            return;
          }

          let dataget = await saveDream(dream);

          if (dataget.data.Message === "ok") {
            toast.success("تم الارسال بنجاح", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else if (dataget.data.Message === "delete") {
            toast.success("هذه الرسالة تم حذفها", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else if (dataget.data.Message === "sent") {
            toast.success("هذه الرسالة غير موجودة", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          }
        } catch (ex) {
          toast.error("يوجد خطأ بالارسال ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          const originalDreams = [...this.state.dataMuraqeeb, dream];
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          this.setState({ dataMuraqeeb: originalDreams });
          if (ex.response && ex.response.status === 404)
            toast.error("This dream has already been deleted.", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
        }
        await this.UpdateALLDATA(dream, dream);
      } else {
        dream["MT_Date"] = new Date();
        dream["ReplyDate"] = new Date();
        dream["isRedyToSent"] = true;
        dream["MsgRegFroSend"] = 1;
        dream["Userlock"] = this.state.user;
        // dream["MT_Reply_Msg"] = msg;
        dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
        dream["IsPending"] = true;
        dream["IsReply"] = true;
        // dream["MT_Englsih"]=key_words;
        //dream["PersonStatus"] = pStatus;
        dream["ReplyUserName"] = this.state.user;

        let originalDreams = [...this.state.dreams];

        const dreams = originalDreams.filter(
          (m) => m.ReplyID !== dream.ReplyID
        );

        //const replyDreams = [...this.state.replyDreams, dream];
        if (!this.state.shouldHide) {
          let dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
          dreamsNONReplyMob = dreamsNONReplyMob.filter(
            (m) => m.ReplyID !== dream.ReplyID
          );

          // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
          let shouldHide = false;
          if (dreamsNONReplyMob.length === 0) {
            shouldHide = true;

            const mobile = "";
            dreamsNONReplyMob = [];
            this.setState({
              dreams,
              dreamsNONReplyMob,
              shouldHide,
              mobile,
              showHide: this.state.showHide2,
              lastUpdateDate: new Date(),
            });
          } else {
            shouldHide = false;
            this.setState({
              dreams,
              dreamsNONReplyMob,
              shouldHide,
              lastUpdateDate: new Date(),
            });
          }
        } else {
          this.setState({ dreams, lastUpdateDate: new Date() });
        }

        //  this.setState({ dreams });

        try {
          if (this.state.isOffline) {
            let data = localStorage.getItem("OfflineData");
            if (data) {
              if (!data.startsWith("[")) {
                data = "[" + data + "]";
              }
            }
            let offlinedata = JSON.parse(data);
            // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
            if (offlinedata) {
              offlinedata = [...offlinedata, dream];
              this.setState({ OfflineData: offlinedata });
              offlinedata = JSON.stringify(offlinedata);
              localStorage.setItem("OfflineData", offlinedata);
            } else {
              this.setState({ OfflineData: dream });
              localStorage.setItem("OfflineData", JSON.stringify(dream));
            }
            return;
          }

          // await saveDream(dream);
          let dataget = await saveDream(dream);
          //////////console.log(dataget);
          //////////console.log(dataget.data.Message === "ok");
          if (dataget.data["Message"] === "ok") {
            toast.success("تم الارسال بنجاح", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else if (dataget.data["Message"] === "delete") {
            toast.success("هذه الرسالة تم حذفها", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else if (dataget.data["Message"] === "sent") {
            toast.success("هذه الرسالة غير موجودة", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          }
          // if (data.data.Data) {
          //   let newDreams = [...this.state.dreams, data.data.Data];

          //   this.setState({
          //     dreams: newDreams
          //   });
          // }
          // if (data.data.Muraqeeb) {
          //   let Muraqeeb = data.data.Muraqeeb;

          //   this.setState({
          //     dataMuraqeeb: Muraqeeb
          //   });
          // }
        } catch (ex) {
          toast.error("يوجد خطأ بالارسال ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });

          const originalDreams = [...this.state.dreams, dream];

          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          //   let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          this.setState({ dreams: originalDreams });
          if (ex.response && ex.response.status === 404)
            toast.error("This dream has already been deleted.", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
        }
        await this.UpdateALLDATA(dream, dream);
      }
    } else {
      if (this.state.user.length > 0) {
        dream["CheckerName"] = "adib@salmustasharak.com";
        // //////////console.log(this.state.user);

        if (dream["MT_Reply_Msg"]) {
          if (dream["MT_Reply_Msg"].length < 7) {
            toast.error("اكتب الرسالة اولا ", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
            return;
          }
        } else {
          toast.error("اكتب الرسالة اولا ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }

        if (this.state.user) {
          dream["MT_Date"] = new Date();
          dream["ReplyDate"] = new Date();
          dream["isRedyToSent"] = false;
          dream["MsgRegFroSend"] = 1;
          dream["Userlock"] = this.state.user;
          // dream["MT_Reply_Msg"] = msg;
          dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
          dream["IsPending"] = true;
          dream["IsReply"] = true;
          // dream["MT_Englsih"]=key_words;
          //dream["PersonStatus"] = pStatus;
          dream["ReplyUserName"] = this.state.user;

          let originalDreams = [...this.state.dreams];

          const dreams = originalDreams.filter(
            (m) => m.ReplyID !== dream.ReplyID
          );

          //const replyDreams = [...this.state.replyDreams, dream];
          if (!this.state.shouldHide) {
            let dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
            dreamsNONReplyMob = dreamsNONReplyMob.filter(
              (m) => m.ReplyID !== dream.ReplyID
            );
            // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
            let shouldHide = false;
            if (dreamsNONReplyMob.length === 0) {
              shouldHide = true;

              const mobile = "";
              dreamsNONReplyMob = [];
              this.setState({
                dreams,
                dreamsNONReplyMob,
                shouldHide,
                mobile,
                showHide: this.state.showHide2,
                lastUpdateDate: new Date(),
              });
            } else {
              shouldHide = false;
              this.setState({
                dreams,
                dreamsNONReplyMob,
                shouldHide,
                lastUpdateDate: new Date(),
              });
            }
          } else {
            this.setState({ dreams, lastUpdateDate: new Date() });
          }

          //  this.setState({ dreams });

          try {
            if (this.state.isOffline) {
              let data = localStorage.getItem("OfflineData");
              if (data) {
                if (!data.startsWith("[")) {
                  data = "[" + data + "]";
                }
              }
              let offlinedata = JSON.parse(data);
              // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
              if (offlinedata) {
                offlinedata = [...offlinedata, dream];
                this.setState({ OfflineData: offlinedata });
                offlinedata = JSON.stringify(offlinedata);
                localStorage.setItem("OfflineData", offlinedata);
              } else {
                this.setState({ OfflineData: dream });
                localStorage.setItem("OfflineData", JSON.stringify(dream));
              }
              return;
            }

            // await saveDream(dream);
            let dataget = await saveDream(dream);
            //////////console.log(dataget.data.Message);
            //////////console.log(dataget.data.Message === "ok");
            if (dataget.data["Message"] === "ok") {
              toast.success("تم الارسال بنجاح", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
            } else if (dataget.data["Message"] === "delete") {
              toast.success("هذه الرسالة تم حذفها", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
            } else if (dataget.data["Message"] === "sent") {
              toast.success("هذه الرسالة غير موجودة", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
            }

            // if (data.data.Data) {
            //   let newDreams = [...this.state.dreams, data.data.Data];

            //   this.setState({
            //     dreams: newDreams
            //   });
            // }
            // if (data.data.Muraqeeb) {
            //   let Muraqeeb = data.data.Muraqeeb;

            //   this.setState({
            //     dataMuraqeeb: Muraqeeb
            //   });
            // }
          } catch (ex) {
            toast.error("يوجد خطأ بالارسال ", {
              position: toast.POSITION.BOTTOM_LEFT,
            });

            const originalDreams = [...this.state.dreams, dream];

            let data = localStorage.getItem("OfflineData");
            if (data) {
              if (!data.startsWith("[")) {
                data = "[" + data + "]";
              }
            }
            let offlinedata = JSON.parse(data);
            //   let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
            if (offlinedata) {
              offlinedata = [...offlinedata, dream];
              this.setState({ OfflineData: offlinedata });
              offlinedata = JSON.stringify(offlinedata);
              localStorage.setItem("OfflineData", offlinedata);
            } else {
              this.setState({ OfflineData: dream });
              localStorage.setItem("OfflineData", JSON.stringify(dream));
            }
            this.setState({ dreams: originalDreams });
            if (ex.response && ex.response.status === 404)
              toast.error("This dream has already been deleted.", {
                position: toast.POSITION.BOTTOM_LEFT,
              });
          }
        }
        await this.UpdateALLDATA(dream, null);
      }
    }
    this.setState({
      isStop: true,
    });
  };

  handleLike = async (dream) => {
    function checkDream(dreams) {
      return dreams.ReplyID === dream.ReplyID;
    }

    dream["UserTranslate"] = this.state.lastID;
    const dreams = [...this.state.dreams];
    const index = dreams.findIndex(checkDream);
    if (!this.state.shouldHide) {
      const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
      const indexM = dreamsNONReplyMob.findIndex(checkDream);

      dreamsNONReplyMob[indexM].isprivate =
        !dreamsNONReplyMob[indexM].isprivate;
      dreams[index] = { ...dreams[index] };
      dreams[index].isprivate = !dreams[index].isprivate;
      dream.isprivate = !dream.isprivate;

      this.setState({ dreams, dreamsNONReplyMob });
    } else {
      dreams[index] = { ...dreams[index] };
      dreams[index].isprivate = !dreams[index].isprivate;
      dream.isprivate = !dream.isprivate;

      this.setState({ dreams });
    }

    try {
      let dataget = await saveDream(dream);

      if (dataget.data.Message === "ok") {
        toast.success("تم الارسال بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } else if (dataget.data.Message === "delete") {
        toast.success("هذه الرسالة تم حذفها", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } else if (dataget.data.Message === "sent") {
        toast.success("هذه الرسالة غير موجودة", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.");
    }
  };

  handleLock = async (dream) => {
    //     if (this.state.isOffline) {
    //       return;
    //     }
    //   let dreamtodb = { ...dream };
    //   if (!dream.islock) {
    //     dreamtodb.userlockDate = new Date();
    //     dreamtodb.Userlock = this.state.user;
    //   } else {
    //     dreamtodb.userlockDate = null;
    //     dreamtodb.Userlock = null;
    // }
    //     dreamtodb.islock = !dream.islock;
    //     let data = await POSTLockedـDelete_Dream_(dreamtodb);

    if (
      this.state.user === "adib@salmustasharak.com" ||
      this.state.user === "mohannad@salmustasharak.com"
    ) {
      if (this.state.selectedGenre === "تدقيق") {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="custom-ui">
                <h1>إلغاء حجز حلم</h1>
                <p>هل ترغب إلغاء حجز الحلم</p>
                <button onClick={onClose}>لا</button>
                <button
                  onClick={async () => {
                    function checkDream(dreams) {
                      return dreams.ReplyID === dream.ReplyID;
                    }

                    const dreams = [...this.state.dreams];
                    const index = dreams.findIndex(checkDream);

                    if (this.state.selectedGenre === "تدقيق") {
                      let originalDreams = [...this.state.dataMuraqeeb];
                      const indexM = originalDreams.findIndex(checkDream);
                      if (
                        dream["ReplyUserName"] === "adib@salmustasharak.com" ||
                        dream["ReplyUserName"] === "mohannad@salmustasharak.com"
                      ) {
                        if (dream.islock) {
                          originalDreams[indexM].islock = !dream.islock;
                          originalDreams[indexM].userlockDate = null;
                          originalDreams[indexM].Userlock = "";
                          originalDreams[indexM].IsReply = false;
                          dream.IsReply = false;
                          originalDreams = originalDreams.filter(
                            (m) => m.ReplyID !== dream.ReplyID
                          );
                        } else {
                          originalDreams[indexM].islock = !dream.islock;
                          originalDreams[indexM].userlockDate = new Date();
                          originalDreams[indexM].Userlock = this.state.user;
                        }
                      } else {
                        originalDreams[indexM].islock = !dream.islock;
                        originalDreams[indexM].userlockDate = null;
                        originalDreams[indexM].Userlock = "";
                      }
                      this.setState({ dataMuraqeeb: originalDreams });
                    }
                    if (!this.state.shouldHide) {
                      const dreamsNONReplyMob = [
                        ...this.state.dreamsNONReplyMob,
                      ];
                      const indexM = dreamsNONReplyMob.findIndex(checkDream);

                      dreamsNONReplyMob[indexM].islock = true;
                      dreams[index] = { ...dreams[index] };
                      dreams[index].islock = !dream.islock;
                      dream.islock = !dream.islock;

                      dreams[index].Userlock = this.state.user;
                      dreams[index].userlockDate = new Date();
                      dreams[index].ReplyUserName = this.state.user;
                      dream.userlockDate = new Date();
                      dream.Userlock = this.state.user;
                      dream.ReplyUserName = this.state.user;

                      dreamsNONReplyMob[indexM].Userlock = this.state.user;
                      dreamsNONReplyMob[indexM].userlockDate = new Date();
                      dreamsNONReplyMob[indexM].islock = !dream.islock;
                      dreamsNONReplyMob[indexM].ReplyUserName = this.state.user;
                      this.setState({ dreams, dreamsNONReplyMob });
                    } else {
                      dream.userlockDate = new Date();
                      dream.Userlock = this.state.user;
                      dream.ReplyUserName = this.state.user;

                      dreams[index] = { ...dreams[index] };
                      dreams[index].Userlock = this.state.user;
                      dreams[index].userlockDate = new Date();
                      dreams[index].ReplyUserName = this.state.user;
                      dreams[index].islock = !dream.islock;
                      dream.islock = !dream.islock;

                      this.setState({ dreams });
                    }

                    await PostCashU_MT_UNLOCK_(dream);

                    onClose();

                    return;
                  }}
                >
                  نعم قم بإلغاء حجز الحلم
                </button>
              </div>
            );
          },
        });

        return;
      } else {
        if (
          this.state.user === "adib@salmustasharak.com" ||
          this.state.user === "mohannad@salmustasharak.com"
        ) {
          if (
            dream["ReplyUserName"] === null ||
            dream["ReplyUserName"] === this.state.user
          ) {
            function checkDream(dreams) {
              return dreams.ReplyID === dream.ReplyID;
            }

            const dreams = [...this.state.dreams];
            const index = dreams.findIndex(checkDream);

            if (!this.state.shouldHide) {
              const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
              const indexM = dreamsNONReplyMob.findIndex(checkDream);

              dreamsNONReplyMob[indexM].islock = true;
              dreams[index] = { ...dreams[index] };
              dreams[index].islock = !dream.islock;
              dream.islock = !dream.islock;

              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dreams[index].ReplyUserName = this.state.user;
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;
              dream.ReplyUserName = this.state.user;

              dreamsNONReplyMob[indexM].Userlock = this.state.user;
              dreamsNONReplyMob[indexM].userlockDate = new Date();
              dreamsNONReplyMob[indexM].islock = !dream.islock;
              dreamsNONReplyMob[indexM].ReplyUserName = this.state.user;
              this.setState({ dreams, dreamsNONReplyMob });
            } else {
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;
              dream.ReplyUserName = this.state.user;

              dreams[index] = { ...dreams[index] };
              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dreams[index].ReplyUserName = this.state.user;
              dreams[index].islock = !dream.islock;
              dream.islock = !dream.islock;

              this.setState({ dreams });
            }

            await PostCashU_MT_UNLOCK_(dream);

            return;
          }

          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="custom-ui">
                  <h1>إلغاء حجز حلم</h1>
                  <p>هل ترغب إلغاء حجز الحلم</p>
                  <button onClick={onClose}>لا</button>
                  <button
                    onClick={async () => {
                      function checkDream(dreams) {
                        return dreams.ReplyID === dream.ReplyID;
                      }

                      const dreams = [...this.state.dreams];
                      const index = dreams.findIndex(checkDream);

                      if (!this.state.shouldHide) {
                        const dreamsNONReplyMob = [
                          ...this.state.dreamsNONReplyMob,
                        ];
                        const indexM = dreamsNONReplyMob.findIndex(checkDream);

                        dreamsNONReplyMob[indexM].islock = true;
                        dreams[index] = { ...dreams[index] };
                        dreams[index].islock = !dream.islock;
                        dream.islock = !dream.islock;

                        dreams[index].Userlock = this.state.user;
                        dreams[index].userlockDate = new Date();
                        dreams[index].ReplyUserName = this.state.user;
                        dream.userlockDate = new Date();
                        dream.Userlock = this.state.user;
                        dream.ReplyUserName = this.state.user;

                        dreamsNONReplyMob[indexM].Userlock = this.state.user;
                        dreamsNONReplyMob[indexM].userlockDate = new Date();
                        dreamsNONReplyMob[indexM].islock = !dream.islock;
                        dreamsNONReplyMob[indexM].ReplyUserName =
                          this.state.user;
                        this.setState({ dreams, dreamsNONReplyMob });
                      } else {
                        dream.userlockDate = new Date();
                        dream.Userlock = this.state.user;
                        dream.ReplyUserName = this.state.user;

                        dreams[index] = { ...dreams[index] };
                        dreams[index].Userlock = this.state.user;
                        dreams[index].userlockDate = new Date();
                        dreams[index].ReplyUserName = this.state.user;
                        dreams[index].islock = !dream.islock;
                        dream.islock = !dream.islock;

                        this.setState({ dreams });
                      }

                      await PostCashU_MT_UNLOCK_(dream);

                      onClose();

                      return;
                    }}
                  >
                    نعم قم بإلغاء حجز الحلم
                  </button>
                </div>
              );
            },
          });

          return;
        }
      }
    }

    if (!dream.islock) {
      try {
        if (this.state.isOffline) {
          return;
        }

        let dreamtodb = { ...dream };
        dreamtodb.userlockDate = new Date();
        dreamtodb.Userlock = this.state.user;
        dreamtodb.islock = true;
        let data = await POSTLockedـDelete_Dream_(dreamtodb);
        if (data.data.Message === "ok") {
          function checkDream(dreams) {
            return dreams.ReplyID === dream.ReplyID;
          }

          const dreams = [...this.state.dreams];
          const index = dreams.findIndex(checkDream);
          if (!this.state.shouldHide) {
            const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
            const indexM = dreamsNONReplyMob.findIndex(checkDream);

            dreamsNONReplyMob[indexM].islock =
              !dreamsNONReplyMob[indexM].islock;
            dreams[index] = { ...dreams[index] };
            dreams[index].islock = !dreams[index].islock;
            dream.islock = !dream.islock;

            if (!dream.islock) {
              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;

              dreamsNONReplyMob[indexM].Userlock = this.state.user;
              dreamsNONReplyMob[indexM].userlockDate = new Date();
            } else {
              dreams[index].Userlock = "";
              dreams[index].userlockDate = null;
              dream.userlockDate = null;
              dream.Userlock = "";
              // dreamsNONReplyMob[indexM].Userlock = this.state.user;
              // dreamsNONReplyMob[indexM].userlockDate = new Date();

              dreamsNONReplyMob[indexM].Userlock = "";
              dreamsNONReplyMob[indexM].userlockDate = null;
            }

            ////////////console.log("success");
            this.setState({ dreams, dreamsNONReplyMob });
          } else {
            if (!dream.islock) {
              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;
            } else {
              dreams[index].Userlock = "";
              dreams[index].userlockDate = null;
              dream.userlockDate = null;
              dream.Userlock = "";
            }
            dreams[index] = { ...dreams[index] };
            dreams[index].islock = !dreams[index].islock;
            dream.islock = !dream.islock;
            // //////////console.log("success");
            this.setState({ dreams });
            //  //////////console.log(dreams);
          }
        } else if (data.data.Message === "locked") {
          toast.warn("هذا الحلم محجوز من قبل مفسر آخر", {
            position: toast.POSITION.BOTTOM_LEFT,
          });

          if (
            this.state.user === "adib@salmustasharak.com" ||
            this.state.user === "mohannad@salmustasharak.com"
          ) {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className="custom-ui">
                    <h1>إلغاء حجز حلم</h1>
                    <p>هل ترغب إلغاء حجز الحلم</p>
                    <button onClick={onClose}>لا</button>
                    <button
                      onClick={async () => {
                        function checkDream(dreams) {
                          return dreams.ReplyID === dream.ReplyID;
                        }

                        const dreams = [...this.state.dreams];
                        const index = dreams.findIndex(checkDream);

                        if (!this.state.shouldHide) {
                          const dreamsNONReplyMob = [
                            ...this.state.dreamsNONReplyMob,
                          ];
                          const indexM =
                            dreamsNONReplyMob.findIndex(checkDream);

                          dreamsNONReplyMob[indexM].islock = true;
                          dreams[index] = { ...dreams[index] };
                          dreams[index].islock = true;
                          dream.islock = true;

                          dreams[index].Userlock = this.state.user;
                          dreams[index].userlockDate = new Date();
                          dreams[index].ReplyUserName = this.state.user;
                          dream.userlockDate = new Date();
                          dream.Userlock = this.state.user;
                          dream.ReplyUserName = this.state.user;

                          dreamsNONReplyMob[indexM].Userlock = this.state.user;
                          dreamsNONReplyMob[indexM].userlockDate = new Date();
                          dreamsNONReplyMob[indexM].islock = true;
                          dreamsNONReplyMob[indexM].ReplyUserName =
                            this.state.user;
                          this.setState({ dreams, dreamsNONReplyMob });
                        } else {
                          dream.userlockDate = new Date();
                          dream.Userlock = this.state.user;
                          dream.ReplyUserName = this.state.user;

                          dreams[index] = { ...dreams[index] };
                          dreams[index].Userlock = this.state.user;
                          dreams[index].userlockDate = new Date();
                          dreams[index].ReplyUserName = this.state.user;
                          dreams[index].islock = true;
                          dream.islock = true;

                          this.setState({ dreams });
                        }

                        await PostCashU_MT_UNLOCK_(dream);

                        onClose();

                        return;
                      }}
                    >
                      نعم قم بإلغاء حجز الحلم
                    </button>
                  </div>
                );
              },
            });
          }
          return;
        } else if (data.data.Message === "deleted") {
          toast.warn("هذا الحلم محذوف ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });

          return;
        } else if (data.data.Message === "replyed") {
          toast.warn("هذا الحلم تم الرد عليه ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return;
        }
      } catch (ex) {
        // toast.error("يوجد خطأ بالحفظ ", {
        //   position: toast.POSITION.BOTTOM_LEFT
        // });
        //////////console.log(ex);
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
      }
    } else {
      if (dream.islock && dream.Userlock === this.state.user) {
        if (this.state.isOffline) {
          return;
        }
        dream.userlockDate = new Date();
        dream.Userlock = this.state.user;
        dream.islock = true;
        let data = await POSTLockedـDelete_Dream_(dream);
        if (data.data.Message === "ok") {
          function checkDream(dreams) {
            return dreams.ReplyID === dream.ReplyID;
          }
          //////////console.log(dream);
          dream["UserTranslate"] = this.state.lastID;
          const dreams = [...this.state.dreams];
          const index = dreams.findIndex(checkDream);
          if (!this.state.shouldHide) {
            const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
            const indexM = dreamsNONReplyMob.findIndex(checkDream);

            dreamsNONReplyMob[indexM].islock =
              !dreamsNONReplyMob[indexM].islock;
            dreams[index] = { ...dreams[index] };
            dreams[index].islock = !dreams[index].islock;
            dream.islock = !dream.islock;

            if (!dream.islock) {
              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;

              dreamsNONReplyMob[indexM].Userlock = this.state.user;
              dreamsNONReplyMob[indexM].userlockDate = new Date();
            } else {
              dreams[index].Userlock = "";
              dreams[index].userlockDate = null;
              dream.userlockDate = null;
              dream.Userlock = "";
              // dreamsNONReplyMob[indexM].Userlock = this.state.user;
              // dreamsNONReplyMob[indexM].userlockDate = new Date();

              dreamsNONReplyMob[indexM].Userlock = "";
              dreamsNONReplyMob[indexM].userlockDate = null;
            }
            await PostCashU_MT_UNLOCK_(dream);
            this.setState({ dreams, dreamsNONReplyMob });
          } else {
            if (!dream.islock) {
              dreams[index].Userlock = this.state.user;
              dreams[index].userlockDate = new Date();
              dream.userlockDate = new Date();
              dream.Userlock = this.state.user;
            } else {
              dreams[index].Userlock = "";
              dreams[index].userlockDate = null;
              dream.userlockDate = null;
              dream.Userlock = "";
            }
            dreams[index] = { ...dreams[index] };
            dreams[index].islock = !dreams[index].islock;
            dream.islock = !dream.islock;
            await PostCashU_MT_UNLOCK_(dream);
            this.setState({ dreams });
          }
        }
      } else {
        if (
          this.state.user === "adib@salmustasharak.com" ||
          this.state.user === "mohannad@salmustasharak.com"
        ) {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="custom-ui">
                  <h1>إلغاء حجز حلم</h1>
                  <p>هل ترغب إلغاء حجز الحلم</p>
                  <button onClick={onClose}>لا</button>
                  <button
                    onClick={async () => {
                      function checkDream(dreams) {
                        return dreams.ReplyID === dream.ReplyID;
                      }

                      const dreams = [...this.state.dreams];
                      const index = dreams.findIndex(checkDream);

                      if (!this.state.shouldHide) {
                        const dreamsNONReplyMob = [
                          ...this.state.dreamsNONReplyMob,
                        ];
                        const indexM = dreamsNONReplyMob.findIndex(checkDream);

                        dreamsNONReplyMob[indexM].islock = true;
                        dreams[index] = { ...dreams[index] };
                        dreams[index].islock = true;
                        dream.islock = true;

                        dreams[index].Userlock = this.state.user;
                        dreams[index].userlockDate = new Date();
                        dreams[index].ReplyUserName = this.state.user;
                        dream.userlockDate = new Date();
                        dream.Userlock = this.state.user;
                        dream.ReplyUserName = this.state.user;

                        dreamsNONReplyMob[indexM].Userlock = this.state.user;
                        dreamsNONReplyMob[indexM].userlockDate = new Date();
                        dreamsNONReplyMob[indexM].islock = true;
                        dreamsNONReplyMob[indexM].ReplyUserName =
                          this.state.user;
                        this.setState({ dreams, dreamsNONReplyMob });
                      } else {
                        dream.userlockDate = new Date();
                        dream.Userlock = this.state.user;
                        dream.ReplyUserName = this.state.user;

                        dreams[index] = { ...dreams[index] };
                        dreams[index].Userlock = this.state.user;
                        dreams[index].userlockDate = new Date();
                        dreams[index].ReplyUserName = this.state.user;
                        dreams[index].islock = true;
                        dream.islock = true;

                        this.setState({ dreams });
                      }

                      await PostCashU_MT_UNLOCK_(dream);

                      onClose();

                      return;
                    }}
                  >
                    نعم قم بإلغاء حجز الحلم
                  </button>
                </div>
              );
            },
          });

          return;
        }
      }
    }
  };
  handelSelect4 = (event) => {
    const btn = { title: event.target.value, active: false, isSC: true };
    this.handleGenreSelect(btn);
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleGenreSelect = (genre, no) => {
    //////console.log(genre);
    //////console.log(no);
    if (no === "1") {
      if (genre.title === "الكل") {
        if (genre.title === this.state.currentsc_new1) {
          this.setState({
            currentsc_new1: "",
          });
        } else {
          this.setState({
            currentMufasser: "الكل",
            currentSC: "الكل",
            currentsc_new1: "الكل",
            currentsc_new2: null,
            currentsc_new3: null,
            currentsc_new4: null,
          });
        }
      } else {
        //////console.log(genre.title);
        //////console.log(this.state.currentsc_new1);
        if (genre.title === this.state.currentsc_new1) {
          this.setState({
            currentsc_new1: "",
          });
        } else {
          this.setState({
            currentsc_new1: genre.title,
          });
        }
      }
    }
    if (no === "2") {
      //////console.log(genre.title);
      //////console.log(this.state.currentsc_new2);
      if (genre.title === this.state.currentsc_new2) {
        this.setState({
          currentsc_new2: "",
        });
      } else {
        this.setState({
          currentsc_new2: genre.title,
        });
      }
    }
    if (no === "3") {
      if (genre.title === this.state.currentsc_new3) {
        this.setState({
          currentsc_new3: "",
        });
      } else {
        this.setState({
          currentsc_new3: genre.title,
        });
      }

      //////console.log(this.state.currentsc_new3);
    }
    if (no === "4") {
      if (genre.title === this.state.currentsc_new4) {
        this.setState({
          currentsc_new4: "",
        });
      } else {
        this.setState({
          currentsc_new4: genre.title,
        });
      }
    }
    if (no === "5") {
      this.setState({
        currentMufasser: genre.title,
      });
    }
    if (no === "6") {
      this.setState({
        currentSC: genre.title,
      });
    }
    if (no === "7") {
      this.setState({
        currentStatus: genre.title,
      });
    }
    if (no === "8") {
      this.setState({
        customerRate: genre.title,
      });
    }
  };
  handelSelectSC = (event) => {
    //////console.log(event.target.value);
    const btn = { title: event.target.value, name: "6" };
    this.handleGenreSelect(btn, "6");
  };
  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedGenre: null,
      currentPage: 1,
      slectedMo: null,
    });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      listOfFillter,
      selectedGenre,
      searchQuery,
      replyDreams,
      dreams: AllDreamsO,
      dreams_Replyed_Deleted,
      currentMufasser,
      currentSC,
      currentsc_new1,
      currentsc_new2,
      currentsc_new3,
      currentsc_new4,
      oldDreams,
      user,
      dataMuraqeeb: OrginaldataMuraqeeb,
      messageLength,
      pcode,
      shouldHide,
      dreamsNONReplyMob,
      currentDate,
      currentStatus,
      offlinedata,
      customerRate,
    } = this.state;
    let slectedMo = null;
    let allDreams = AllDreamsO;

    //  console.log(allDreams);
    //    if (user === "omar@salmustasharak.com") {
    //     allDreams = allDreams.filter((m) => {
    //       return (
    //         m.Userlock === "omar@salmustasharak.com" &&
    //         m.islock === true &&
    //         m.MOShortCode !== 4060 &&
    //         m.MOShortCode !== 3900 &&
    //         m.MOShortCode !== 3839 &&
    //         m.MOShortCode !== 4148
    //       );
    //     });
    //  //    console.log("check 2");
    //   }

    let filtered = allDreams;
    //  if (pcode !== 999) {
    //    console.log(filtered);

    //}
    //console.log(user);

    if (currentsc_new1 === "الكل") {
      filtered = allDreams.filter((m) => {
        return m.isRedyToSent === false;
      });

    }

    if (currentsc_new4 === "تدقيق") {
      filtered = allDreams.filter((m) => {
        return m.IsReply === true && m.isRedyToSent === false;
      });
    } else if (currentsc_new4 !== "المرسلة" || currentsc_new4 !== "المحذوفة") {
      filtered = allDreams.filter((m) => {
        return m.IsReply === false;
      });
    }

    if (currentsc_new4 === "محجوز") {
      if (user === "adib@salmustasharak.com") {
        filtered = filtered.filter((m) => {
          return (
            m.islock === true &&
            m.IsReply === false &&
            m.ReplyUserName === "adib@salmustasharak.com"
          );
        });
      } else {
        filtered = filtered.filter((m) => {
          return m.islock === true && m.IsReply === false;
        });
      }
    }

    if (currentsc_new4 === "المحذوفة") {
      filtered = dreams_Replyed_Deleted.filter((m) => {
        return m.isdelete === true;
      });
    }

    if (currentsc_new4 === "المرسلة") {
      //////console.log(dreams_Replyed_Deleted);
      filtered = dreams_Replyed_Deleted.filter((m) => {
        return m.isRedyToSent === true;
      });
    }
    //Offline
    if (currentsc_new4 === "Offline") {
      //  //////console.log(dreams_Replyed_Deleted);

      let data = localStorage.getItem("OfflineData");
      if (data) {
        if (!data.startsWith("[")) {
          data = "[" + data + "]";
        }
      }
      let offlinedata = JSON.parse(data);
      if (offlinedata) {
        filtered = offlinedata.reverse();
      } else {
        filtered = [];
      }
    }
    if (user == "qutaiba@salmustasharak.com") {
      let DDDDream = allDreams.filter((m) => {
        return (
          (m.MOShortCode !== 4060 &&
            m.IsReply === false &&

            m.islock === true &&
            m.Userlock === "qutaiba@salmustasharak.com") ||
          (m.MOShortCode !== 4060 && m.IsReply === false && m.islock === false)
        );
      });

      allDreams = DDDDream;

      var dToday = new Date();

      dToday.setHours(dToday.getHours() - 24);
      allDreams = allDreams.filter((m) => {
        var date = new Date(m["MO_Date"]);
        return (
          date.getDate() === dToday.getDate() &&
          date.getFullYear() === dToday.getFullYear() &&
          date.getMonth() === dToday.getMonth()
        );
      });

      filtered = allDreams;
    }

    if (user == "alaa@salmustasharak.com") {
      let DDDDream = allDreams.filter((m) => {
        return (
          (m.MOShortCode !== 4060 &&
            m.IsReply === false &&
            m.islock === true &&
            m.ReplyUserName === "alaa@salmustasharak.com") ||
          (m.MOShortCode !== 4060 && m.IsReply === false && m.islock === false)
        );
      });

      allDreams = DDDDream;

      filtered = allDreams;
    }

    if (pcode === 999) {
      if (currentMufasser === "الكل") {
        filtered = filtered;
      } else {
        filtered = filtered.filter((m) => {
          return m.ReplyUserName === currentMufasser;
        });
      }
    }

    //customerRate

    if (customerRate === "100" || customerRate === 100) {
      filtered = filtered;
    } else {
      filtered = filtered.filter((m) => {
        return m["customerRate"] === parseInt(customerRate, 10);
      });
    }

    if (currentSC === "الكل") {
      filtered = filtered;
    } else {
      filtered = filtered.filter((m) => {
        return m["MOShortCode"] === parseInt(currentSC, 10);
      });
    }

    if (currentsc_new1 === "100ح") {
      filtered = filtered.filter((m) => {
        return m["MO_Message"].length <= 200 && m["MO_Message"].length > 50;
      });
    }
    if (currentsc_new1 === "300ح") {
      filtered = filtered.filter((m) => {
        return m["MO_Message"].length >= 220 || m["MO_Message"].length < 51;
      });
    }
    if (currentsc_new1 === "500ح") {
      filtered = filtered.filter((m) => {
        return m["MO_Message"].length >= 500;
      });
    }

    if (currentsc_new1 === "حروف") {
      filtered = filtered.filter((m) => {
        return m["MO_Message"].length <= messageLength;
      });
    }

    if (currentsc_new2 === "اليوم") {
      filtered = filtered.filter((m) => {
        var date = new Date(m["MO_Date"]);
        return (
          date.getDate() === new Date().getDate() &&
          date.getFullYear() === new Date().getFullYear() &&
          date.getMonth() === new Date().getMonth()
        );
      });
    }
    if (currentsc_new2 === "الشهر") {
      filtered = filtered.filter((m) => {
        var date = new Date(m["MO_Date"]);
        return (
          date.getFullYear() === new Date().getFullYear() &&
          date.getMonth() === new Date().getMonth()
        );
      });
    }
    if (currentsc_new2 === "البارحة") {
      filtered = filtered.filter((m) => {
        let yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(
          new Date()
        );

        var MO_Date = new Date(m["MO_Date"]);
        //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

        return (
          MO_Date.getDate() === yesterday.getDate() &&
          MO_Date.getFullYear() === yesterday.getFullYear() &&
          MO_Date.getMonth() === yesterday.getMonth()
        );
      });
    }

    if (currentsc_new2 === "الأسبوع") {
      filtered = filtered.filter((m) => {
        let week = ((d) => new Date(d.setDate(d.getDate() - 7)))(new Date());

        var MO_Date = new Date(m["MO_Date"]);
        //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

        return (
          MO_Date.getDate() >= week.getDate() &&
          MO_Date.getFullYear() === week.getFullYear() &&
          MO_Date.getMonth() === week.getMonth()
        );
      });
    }

    if (currentsc_new2 === "تاريخ") {
      if (currentDate) {
        filtered = filtered.filter((m) => {
          var date_MO_Date = new Date(m["MO_Date"]);
          var currentDate_ = currentDate;
          ////////console.log(currentDate_.getDate());
          return (
            date_MO_Date.getDate() === currentDate_.getDate() &&
            date_MO_Date.getFullYear() === currentDate_.getFullYear() &&
            date_MO_Date.getMonth() === currentDate_.getMonth()
          );
        });
      }
    }

    //customerRate

    if (currentStatus === "الكل") {
      filtered = filtered;
    } else if (currentStatus === "تدقيق") {
      filtered = filtered.filter((m) => {
        if (m["MT_Reply_Msg"]) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      filtered = filtered.filter((m) => {
        return m["MT_Arabic"] === currentStatus;
      });
    }
    if (currentsc_new3 === "فوق2+") {
      filtered = filtered.filter((m) => {
        if (
          filtered.filter((x) => x.MT_Mobil === m["MT_Mobil"]).length > 1 &&
          filtered.filter((x) => x.MT_Mobil === m["MT_Mobil"]).length < 3
        ) {
          return true;
        } else {
          return false;
        }
      });
    }



    if (currentsc_new3 === "فوق5+") {
      filtered = filtered.filter((m) => {
        if (
          filtered.filter((x) => x.MT_Mobil === m["MT_Mobil"]).length >= 5 &&
          filtered.filter((x) => x.MT_Mobil === m["MT_Mobil"]).length <= 10
        ) {
          return true;
        } else {
          return false;
        }
      });
    }

    if (currentsc_new3 === "فوق10+") {
      filtered = filtered.filter((m) => {
        if (filtered.filter((x) => x.MT_Mobil === m["MT_Mobil"]).length >= 10) {
          return true;
        } else {
          return false;
        }
      });
    }

    if (currentsc_new4 === "جديد") {
      filtered = filtered.filter((m) => {
        return m["IsNew"] === true;
      });
    }

    if (currentsc_new4 === "خاص") {
      filtered = filtered.filter((m) => {
        return m["isprivate"] === true;
      });
    }
    if (currentsc_new4 === "عام") {
      filtered = filtered.filter((m) => {
        return m["isprivate"] === false;
      });
    }

    if (searchQuery) {
      slectedMo = null;
      // let allDreamsMuraqeebDelete=[...allDreams,...dataMuraqeeb];
      // allDreamsMuraqeebDelete=[...allDreamsMuraqeebDelete,...deleteDreams];
      filtered = filtered.filter((m) => {
        if (m["MO_Message"]) {
          var v = false;
          var boolarray = 0;

          var searcharr = searchQuery.split("-");
          if (searcharr.length > 0) {
            for (var i = 0; i < searcharr.length; i++) {
              if (m["MO_Message"].includes(searcharr[i])) {
                boolarray++;
              }
            }
            if (boolarray && searcharr) {
              if (searcharr.length === boolarray) {
                return true;
              }
            }
          }
          if (m["PersonStatus"]) {
            if (m["MT_Reply_Msg"]) {
              v =
                m["MO_Message"] === searchQuery ||
                m["MT_Reply_Msg"] === searchQuery ||
                m["MT_Mobil"] === searchQuery ||
                m["MT_Mobil"].includes(searchQuery) ||
                m["PersonStatus"].includes(searchQuery) ||
                m["MO_Message"].includes(searchQuery) ||
                m["MT_Reply_Msg"].includes(searchQuery);
            } else {
              v =
                m["MO_Message"] === searchQuery ||
                m["MT_Mobil"] === searchQuery ||
                m["MT_Mobil"].includes(searchQuery) ||
                m["PersonStatus"].includes(searchQuery) ||
                m["MO_Message"].includes(searchQuery);
            }
          } else {
            if (m["MT_Reply_Msg"]) {
              v =
                m["MO_Message"] === searchQuery ||
                m["MT_Reply_Msg"] === searchQuery ||
                m["MT_Mobil"] === searchQuery ||
                m["MT_Mobil"].includes(searchQuery) ||
                //m["PersonStatus"].includes(searchQuery) ||
                m["MO_Message"].includes(searchQuery) ||
                m["MT_Reply_Msg"].includes(searchQuery);
            } else {
              v =
                m["MO_Message"] === searchQuery ||
                m["MT_Mobil"] === searchQuery ||
                m["MT_Mobil"].includes(searchQuery) ||
                //m["PersonStatus"].includes(searchQuery) ||
                m["MO_Message"].includes(searchQuery);
            }
          }
          return v;
        } else {
          return (
            m["MO_Message"] === searchQuery ||
            m["PersonStatus"] === searchQuery ||
            m["MT_Mobil"] === searchQuery
          );
        }
      });
    }

    var lengthSorter = function (value) {
      if (value["MO_Message"] == null) {
        return 0;
      }
      return value["MO_Message"].length;
    };
    var lengthSorterReply = function (value) {
      if (value["Userlock"] == null) {
        return 0;
      } else if (value["Userlock"] == "qutaiba@salmustasharak.com") { return value["Userlock"].length; }

    };

    let sorted =
      sortColumn.path === "MO_Message"
        ? _.orderBy(filtered, lengthSorter, [sortColumn.order])
        : _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    if (user === "qutaiba@salmustasharak.com") {
      sorted = _.orderBy(
        filtered,
        [lengthSorterReply, "MO_Date"],
        ["desc", "asc"]
      );
    }

    if (user === "alaa@salmustasharak.com") {
      sorted = _.orderBy(
        filtered,
        [lengthSorterReply, "MO_Date"],
        ["desc", "asc"]
      );
    }


    const dreams = paginate(sorted, currentPage, pageSize);
    let filtered_Length = this.state.dreams;
    let totalCount_Sent;
    if (replyDreams) {
      totalCount_Sent = replyDreams.length;
    }

    let totalCount_Muraqeeb = filtered_Length.filter((m) => {
      if (m) {
        var date = new Date(m["MO_Date"]);
        if (
          m["CheckerName"] != null &&
          date.getDate() === new Date().getDate() &&
          date.getMonth() === new Date().getMonth() &&
          date.getFullYear() === new Date().getFullYear() &&
          m["CheckerName"] === "muraqib" && //this.state.user &&
          m["isRedyToSent"] === true &&
          m["isdelete"] === false
        ) {
          return true;
        }
      }
      return false;
    }).length;
    if (filtered) {
      return {
        totalCount: filtered.length,
        totalCountSent: totalCount_Sent,
        totalCountMuraqeeb: totalCount_Muraqeeb,
        data: dreams,
      };
    } else {
      return { totalCount: 0, data: dreams };
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="my-nice-tab-container">
          <div className="loading-state">
            <p>جاري تحميل البيانات</p>
          </div>
        </div>
      );
    } else {
      const { length: count } = this.state.dreams;
      const { pageSize, currentPage, sortColumn, searchQuery } = this.state;
      // const { user } = this.props;

      if (count === 0) return <p>جاري تحميل البيانات</p>;

      const {
        totalCount,

        data: dreams,
      } = this.getPagedData();

      return (
        <React.Fragment>
          <NavBar user={this.state.user} pcode={this.state.pcode} />

          <Modal
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={{
              overlay: {
                backgroundColor: "papayawhip",
                zIndex: 100,
              },
            }}
          >
            <div>
              {" "}
              <button
                onClick={this.closeModal}
                className="btn text-right btn-success btn-sm"
              >
                اغلاق النافذة
              </button>
            </div>
            <AllDreams mobOldData={this.state.alldata} />
          </Modal>

          <div className="row control-panel">
            {this.state.pcode === 999 ? (
              <React.Fragment>
                <div className="col-12 col-xl-7 col-lg-12 col-md-12 col-sm-12 text-right">
                  <div className="control-card">
                    <div className="control-title">لوحة التحكم</div>
                    <ListGroup
                      sc_new1={this.state.sc_new1}
                      sc_new2={this.state.sc_new2}
                      sc_new3={this.state.sc_new3}
                      sc_new4={this.state.sc_new4}
                      currentMufasser={this.state.currentMufasser}
                      currentSC={this.state.currentSC}
                      currentsc_new1={this.state.currentsc_new1}
                      currentsc_new2={this.state.currentsc_new2}
                      currentsc_new3={this.state.currentsc_new3}
                      currentsc_new4={this.state.currentsc_new4}
                      sc={this.state.sc}
                      selectedItem={this.state.selectedGenre}
                      onItemSelect={this.handleGenreSelect}
                      pcode={this.state.pcode}
                      selectedStatus={this.state.currentStatus}
                      dreams={this.state.dreams}
                      customerRate={this.state.customerRate}
                    />
                    <div className="control-row">
                      <div className="control-item">
                        <span className="control-label">تاريخ الرسالة</span>
                        <DatePicker
                          selected={this.state.currentDate}
                          onChange={this.handleChangeDP}
                          dateFormat="dd-MMMM-yyyy"
                          className="form-control control-input date-picker-input"
                          wrapperClassName="date-picker-wrapper"
                          calendarClassName="date-picker-calendar"
                          popperClassName="date-picker-popper"
                          popperPlacement="top-start"
                          popperModifiers={{
                            offset: { enabled: true, offset: "0,8" },
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: "viewport",
                            },
                            flip: {
                              enabled: true,
                              behavior: ["top-start", "bottom-start"],
                            },
                          }}
                          showPopperArrow={false}
                        />
                      </div>
                      <div className="control-item control-item--small">
                        <span className="control-label">عدد الحروف</span>
                        <input
                          type="text"
                          name="messageLength"
                          id="messageLength"
                          value={
                            this.state.messageLength
                              ? this.state.messageLength
                              : ""
                          }
                          onChange={this.handleMessageLength}
                          className="form-control control-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xl-5 col-lg-12 col-md-12 col-sm-12 text-right">
                  <div className="control-card stats-card">
                    <div className="control-title">إحصائيات سريعة</div>
                    <table className="table stats-table text-center">
                    <thead>
                      <tr style={{ color: "darkBule", fontWeight: "bold" }}>


                        <th scope="col">منى</th>

                        <th scope="col">أديب</th>

                        <th scope="col">رسائل</th>
                        <th scope="col">س م س </th>
                        <th scope="col" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ color: "red", fontWeight: "bold" }}>


                        <td>{this.state.mohannadD}</td>

                        <td>{this.state.adibD}</td>
                        <td>{this.state.TodayCount}</td>
                        <td>{this.state.TodaySMS}</td>
                        <td>اليوم</td>
                      </tr>
                      <tr style={{ color: "blue", fontWeight: "bold" }}>


                        <td>{this.state.mohannadY}</td>

                        <td>{this.state.adibY}</td>
                        <td>{this.state.yesterdayCount}</td>
                        <td>{this.state.yesterdaySMS}</td>
                        <td>البارحة</td>
                      </tr>
                      <tr style={{ color: "Bule", fontWeight: "bold" }}>


                        <td>{this.state.mohannadM}</td>

                        <td>{this.state.adibM}</td>
                        <td>{this.state.MonthCount}</td>
                        <td>{this.state.MonthSMS}</td>
                        <td>الشهر</td>
                      </tr>
                      <tr style={{ color: "darkgreen", fontWeight: "bold" }}>


                        <td>{this.state.mohannadLM}</td>

                        <td>{this.state.adibLM}</td>
                        <td>{this.state.oldmonthCount}</td>
                        <td>{this.state.oldmonthSMS}</td>
                        <td>الشهر السابق</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              ""
            )}
          </div>

          <div className="row">
            <div className="col-lg-12">
              {this.state.pcode === 999 ? (
                <React.Fragment>
                  {/*      {user && (
              <Link
                to="/ddreams/new"
                className="btn btn-primary"
                style={{ marginBottom: 10 }}
              >
                New Dream
              </Link>
            )} */}
                  لديك <font color="blue">{this.state.oldDreams.length}</font>{" "}
                  حلم في قاعدة البيانات. &nbsp;&nbsp;
                  <div className="pull-right">
                    <div className="form-group row">
                      &nbsp;&nbsp; &nbsp;&nbsp;{" "}
                      <i
                        color="red"
                        style={{ cursor: "pointer" }}
                        className={
                          this.state.showHide
                            ? "fa fa-eye-slash fa-2x text-danger"
                            : "fa fa-eye fa-2x text-success"
                        }
                        onClick={this.handleShowHide}
                      />
                      &nbsp;&nbsp; &nbsp;&nbsp;{" "}
                      <i
                        color="blue"
                        style={{ cursor: "pointer" }}
                        className={
                          this.state.showHideDoc
                            ? "fa fa-eye-slash fa-2x text-danger"
                            : "fa fa-eye fa-2x text-success"
                        }
                        onClick={this.handleShowHideDoc}
                      />
                      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      <div className="col-xs-1">
                        لديك <font color="blue">{totalCount}</font> حلم في قاعدة
                        البيانات. &nbsp;&nbsp;
                        <i
                          className="fa fa-calendar"
                          aria-hidden="true"
                          onClick={this.renderSortDate}
                          style={{ cursor: "pointer" }}
                        />
                        &nbsp;&nbsp;{" "}
                        <i
                          className="fa fa-free-code-camp"
                          aria-hidden="true"
                          onClick={this.renderSortDate2}
                          style={{ cursor: "pointer" }}
                        />
                        &nbsp;&nbsp;{" "}
                      </div>
                      &nbsp;&nbsp; &nbsp;&nbsp;
                      <div className="col-xs-1">
                        {this.state.loadeddata ? (
                          <i
                            className="fa fa-refresh"
                            aria-hidden="true"
                            onClick={this.handlerefreshData}
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          <i className="fa fa-spinner" aria-hidden="true" />
                        )}
                        &nbsp;&nbsp; &nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {this.state.pcode !== 999 ? (
                <React.Fragment>
                  <ListGroup
                    sc_new1={this.state.sc_new1}
                    sc_new2={this.state.sc_new2}
                    sc_new3={this.state.sc_new3}
                    sc_new4={this.state.sc_new4}
                    currentMufasser={this.state.currentMufasser}
                    currentSC={this.state.currentSC}
                    currentsc_new1={this.state.currentsc_new1}
                    currentsc_new2={this.state.currentsc_new2}
                    currentsc_new3={this.state.currentsc_new3}
                    currentsc_new4={this.state.currentsc_new4}
                    sc={this.state.sc}
                    selectedItem={this.state.selectedGenre}
                    onItemSelect={this.handleGenreSelect}
                    pcode={this.state.pcode}
                    selectedStatus={this.state.currentStatus}
                  />
                </React.Fragment>
              ) : (
                ""
              )}

              {this.state.pcode > 10 && this.state.pcode < 999 ? (
                <React.Fragment>
                  <select
                    className="selectpicker"
                    onChange={this.handelSelectSC}
                  >
                    <option
                      value="الكل"
                      key="الكل"
                      className={
                        "الكل" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      الكل
                    </option>

                    <option
                      value="4024"
                      key="4024"
                      className={
                        "4024" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      أسود
                    </option>
                    <option
                      value="3900"
                      key="3900"
                      className={
                        "4024" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      2أسود
                    </option>
                    {this.state.pcode > 777 && (
                      <option
                        value="6055"
                        key="6055"
                        className={
                          "6055" === this.state.selectedItem
                            ? "list-group-item active"
                            : "list-group-item"
                        }
                      >
                        أخضر
                      </option>
                    )}
                    <option
                      value="6877"
                      key="6877"
                      className={
                        "6877" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      أحمر
                    </option>
                    <option
                      value="4022"
                      key="4022"
                      className={
                        "4022" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      بنفسجي
                    </option>
                    <option
                      value="2337"
                      key="2337"
                      className={
                        "2337" === this.state.selectedItem
                          ? "list-group-item active"
                          : "list-group-item"
                      }
                    >
                      أزرق
                    </option>
                  </select>
                </React.Fragment>
              ) : (
                ""
              )}

              {this.state.pcode !== 999 ? (
                <div className="control-card control-inline-card">
                  <div className="control-inline">
                    <div className="control-icon-group">
                      <i
                        color="red"
                        style={{ cursor: "pointer" }}
                        className={
                          this.state.showHide
                            ? "fa fa-eye-slash fa-2x text-danger"
                            : "fa fa-eye fa-2x text-success"
                        }
                        onClick={this.handleShowHide}
                      />
                    </div>
                    {this.state.pcode < 777 ? (
                      ""
                    ) : (
                      <React.Fragment>
                        <div className="control-item">
                          <span className="control-label">تاريخ الرسالة</span>
                          <DatePicker
                            selected={this.state.currentDate}
                            onChange={this.handleChangeDP}
                            dateFormat="dd-MMMM-yyyy"
                            className="form-control control-input date-picker-input"
                            wrapperClassName="date-picker-wrapper"
                            calendarClassName="date-picker-calendar"
                            popperClassName="date-picker-popper"
                            popperPlacement="top-start"
                            popperModifiers={{
                              offset: { enabled: true, offset: "0,8" },
                              preventOverflow: {
                                enabled: true,
                                boundariesElement: "viewport",
                              },
                              flip: {
                                enabled: true,
                                behavior: ["top-start", "bottom-start"],
                              },
                            }}
                            showPopperArrow={false}
                          />
                        </div>
                        <div className="control-item control-item--small">
                          <span className="control-label">عدد الحروف</span>
                          <input
                            type="text"
                            name="messageLength"
                            id="messageLength"
                            value={
                              this.state.messageLength
                                ? this.state.messageLength
                                : ""
                            }
                            onChange={this.handleMessageLength}
                            className="form-control control-input"
                          />
                        </div>
                      </React.Fragment>
                    )}
                    <div className="control-item">
                      <span className="control-label">الإجمالي</span>
                      <div className="control-value">
                        لديك <font color="blue">{totalCount}</font> حلم في قاعدة
                        البيانات.
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {this.state.pcode > 776 ? (
                <SearchBox value={searchQuery} onChange={this.handleSearch} />
              ) : (
                ""
              )}
            </div>

            {!this.state.showHideDoc && this.state.shouldHide && (
              <React.Fragment>
                <div className="row flex-nowrap">
                  <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right flex-nowrap">
                    <Pagination
                      itemsCount={totalCount}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      onPageChange={this.handlePageChange}
                    />
                    <DreamsTable
                      dreams={dreams}
                      sortColumn={sortColumn}
                      onLike={this.handleLike}
                      onLock={this.handleLock}
                      onKeywordsMsg={this.handleKeywordsMsg}
                      onDelete={this.handleDeleteConfirm}
                      onOpenModel={this.openModal}
                      onSort={this.handleSort}
                      onOPTOUT={this.handleImage}
                      OnAction={this.handledeleteDreamAction}
                      showHide={this.state.showHide}
                      showHide2={this.state.showHide2}
                      pcode={this.state.pcode}
                      onChangeText={this.handleChangeInput}
                      onGetAll={this.handleGetAll}
                      onUnLockAll={this.onUnLockAll}
                      shouldHide={this.state.shouldHide}
                      orginalDreams={this.state.dreams}
                      user={this.state.user}
                      isMuraqeeb={this.state.selectedGenre}
                      onSendMsg={this.handleAdminSendMessage}
                    />
                    <Pagination
                      itemsCount={totalCount}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      onPageChange={this.handlePageChange}
                    />{" "}
                  </div>
                </div>
              </React.Fragment>
            )}

            {!this.state.showHideDoc && !this.state.shouldHide && (
              <DreamsTableMob
                user={this.state.user}
                pcode={this.state.pcode}
                sortColumn={sortColumn}
                mob={this.state.mobile}
                dreamsNONReplyMob={this.state.dreamsNONReplyMob}
                onSort={this.handleSort}
                OnAction={this.handledeleteDreamAction}
                onUnLockAll={this.onUnLockAll}
                onChangeText={this.handleChangeInput}
                orginalDreams={this.state.dreams}
                onOpenModel={this.openModal}

              />
            )}

            {this.state.showHideDoc && (
              <div className="row flex-nowrap">
                <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right flex-nowrap">
                  <DreamsTableForDoc
                    dreams={dreams}
                    sortColumn={sortColumn}
                    onSort={this.handleSort}
                  />
                </div>
              </div>
            )}

            {!this.state.showHideDoc && !this.state.shouldHide && (
              <AllDreams pcode={this.state.pcode} mob={this.state.mobile} />
            )}
          </div>
        </React.Fragment>
      );
    }
  }
}

export default Dreams;



// WEBPACK FOOTER //
// ./src/components/dreams.jsx